/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { ColumnCounts } from "./ColumnCounts";

/**
 * One column of an automation's timeline, left to right: its stage, what
 * it is, its time (first: from the event; after: the gap after the column
 * to its left finished; wait: 0), its header's words ("Right away", "2
 * days later", "When “Intake call” is marked done"), its steps (a wait
 * column's wait first), and how many people it has going now.
 */
export type ColumnResponse = {
  stage: number;
  kind: ColumnResponse.kind;
  offset_minutes: number;
  position: string;
  step_ids: Array<number>;
  counts: ColumnCounts;
};

export namespace ColumnResponse {
  export enum kind {
    FIRST = "first",
    WAIT = "wait",
    AFTER = "after",
  }
}
